module.exports = __webpack_public_path__ + "img/bg-cursos-pos.33fa5b9a.png";